import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'app-spark-agreement',
  standalone: false,
  templateUrl: './spark-agreement.component.html'
})
export class SparkAgreementComponent {
  @Input() id: any;
  @Input() getUrl: string;
  @Input() postUrl: string;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  commentForm: FormGroup;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() stepDetails: any;
  @Input() schemeType: string;
  init: EditorComponent['init'] = init;

  baseUrl = environment.APIUrl
  isEdit: boolean = false;
  sparkData: any;
  vendersData: any;
  payload: any;
  sparkForm: FormGroup = new FormGroup({
    id: new FormControl(null),
    challenge_title: new FormControl('', Validators.required),
    category: new FormControl('', Validators.required),
    development_budget: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.min(0.01)]),
    start_date: new FormControl('', Validators.required),
    end_date: new FormControl('', Validators.required),

  });
  showVersionColumn: boolean = false;
  constructor(
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {

  }

  ngOnInit(): void {
    this.isEditMode = false;

    this.isEdit = this.stepDetails.can_edit || sessionStorage.getItem('user_role_id') === '19';
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });

    this.getSparkDetails();
    // this.getWbsData();

  }

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  expandedSections: { [key: string]: boolean } =
    {
      basicInfo: true,
      equipment: false,
      quantity: false,
      cost: false,
      detailedInfo: false,
      uploads: false,
      vendorTable: false
    };



  getSparkDetails() {
    this.api.getAPI(`/idex/spark/grant/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`)
      .subscribe((res: any) => {
        if (res) {
          this.sparkData = res;
          this.milestones = res.milestone_data;
          this.sparkForm.patchValue({
            challenge_title: res.challenge_title,
            category: res.category,
            development_budget: res.data.development_budget,
            start_date: res.data.start_date,
            end_date: res.data.end_date,
            id: res.data.id,
          });
          this.buildVendorTabs(res)
        }
      });
  }


  tableColumns: string[] = []

  //  buildVendorTabs(res: any) {
  //     const vendorMap = res?.vendors || {};

  //     this.vendorTabs = Object.keys(vendorMap).map((name, index) => ({
  //       label: `Vendor ${index + 1}`,
  //       name: name,
  //       data: vendorMap[name] || []
  //     }));

  //     this.activeVendorIndex = 0;
  //   }


  onSubmit(): void {
    const formData = new FormData();
    const payload = this.sparkForm.value;

    formData.append('challenge_title', payload.challenge_title);
    formData.append('category', payload.category);
    formData.append('development_budget', payload.development_budget);
    formData.append('matching_contribution', payload.matching_contribution);
    payload.start_date ? formData.append('start_date', payload.start_date) : '';
    payload.end_date ? formData.append('end_date', payload.end_date) : '';
    formData.append('id', payload.id);


    this.api.putAPI(`/idex/spark/grant/${payload.id}/`, formData).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Data updated successfully',
      });
      this.getSparkDetails();
    })
  }

  milestones: any[] = [];

  getWbsData(): void {
    this.api.getAPI(`/idex/upload/wbs/?proposal_step=${this.stepDetails?.id}`).subscribe({
      next: (res: any[]) => {
        this.milestones = Array.isArray(res)
          ? res.map(m => ({
            id: m?.id ?? null,
            title: m?.title ?? '',
            sub_deliverable: m?.sub_deliverable ?? '',
            deliverable: m?.deliverable ?? '',
            tranche: m?.tranche ?? '',
            percentage: m?.percentage ?? '',
            start_date: m?.start_date ?? null,
            end_date: m?.end_date ?? null,
            status: this.getStatus(m)
          }))
          : [];
      },
      error: () => (this.milestones = [])
    });
  }

  getStatus(m: any): string {
    if (!m) return '';
    const today = new Date().toISOString().slice(0, 10);
    const sd = m.start_date?.slice(0, 10) ?? '';
    const ed = m.end_date?.slice(0, 10) ?? '';
    if (!sd && !ed) return '';
    if (ed && ed < today) return 'Delayed';
    if (sd && sd <= today && (!ed || ed >= today)) return 'Ongoing';
    if (ed && ed >= today && (m.percentage == 100 || m.percentage == '100.0' || m.percentage === '100')) return 'Completed';
    return '';
  }

  saveMilestone(m: any): void {
    if (!m?.id) return;
    const payload = {
      proposal: m.proposal ?? this.stepDetails?.proposal ?? null,
      title: m.title || '',
      sub_deliverable: m.sub_deliverable || '',
      deliverable: m.deliverable || '',
      tranche: m.tranche || '',
      percentage: m.percentage ?? '',
      start_date: m.start_date ?? null,
      end_date: m.end_date ?? null,
    };

    this.api.putAPI(`/idex/milestone/${m.id}/`, payload).subscribe({
      next: () => {
        this.getWbsData();
        m.isEditMode = false;
      },
      error: () => { }
    });
  }

  deleteMilestone(m: any): void {
    if (!m?.id) return;
    this.api.deleteAPI(`/idex/milestone/${m.id}/`).subscribe({
      next: () => (this.milestones = this.milestones.filter(x => x?.id !== m.id)),
      error: () => { },
    });
  }

  onFileUpload(v: any, event: any): void {
    const file = event.target.files[0];
    console.log(file);
  }

  signSparkAgreement(v: any): void {
    const fromData = new FormData();

    this.uploadedFiles[v.id]?.['wbs_file'] ? fromData.append('wbs_file', this.uploadedFiles[v.id]?.['wbs_file']) : '';
    this.uploadedFiles[v.id]?.['sign_document'] ? fromData.append('sign_document', this.uploadedFiles[v.id]?.['sign_document']) : '';
    fromData.append('development_budget', v.development_budget);
    fromData.append('matching_contribution', v.matching_contribution);
    v.start_date ? fromData.append('start_date', v.start_date) : '';
    v.end_date ? fromData.append('end_date', v.end_date) : '';

    if (v.wbs_file && v.sign_document) {
      fromData.append('vendor_id', v.vendor?.id);
      fromData.append('spark', this.sparkForm.value.id);
      this.api.postAPI(`/idex/spark/grant/`, fromData).subscribe((res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Uploaded WBS File and Signed Spark Agreement successfully On Vendor',
        });
        this.uploadedFiles = {};
        this.getSparkDetails();
      });

      return;
    }
    fromData.append('vendor_id', v.id);
    this.api.putAPI(`/idex/spark/grant/${this.sparkForm.value.id}/`, fromData).subscribe((res: any) => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Uploaded WBS File and Signed Spark Agreement successfully On Vendor',
      });
      this.uploadedFiles = {};
      this.getSparkDetails();
    });
  }
  uploadedFiles: Record<string, Record<string, File>> = {};

  onFilesSelected(v: any, event: Event, key: string) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    const vendorId = String(v.id ?? '');
    if (!vendorId) {
      console.warn('Missing vendorId', v);
      return;
    }
    if (!this.uploadedFiles[vendorId]) this.uploadedFiles[vendorId] = {};

    this.uploadedFiles[vendorId][key] = file;

    console.log(this.uploadedFiles);
  }


  /* ================= FORM ================= */
  sparkForms: FormGroup = new FormGroup({
    spark_grant_approve: new FormControl('', Validators.required),
    matching_contribution: new FormControl('', Validators.required),
    start_date: new FormControl('', Validators.required),
    end_date: new FormControl('', Validators.required),
    sign_document: new FormControl(null)
  });

  /* ================= TABLE ================= */
  vendorTabs: any[] = [];
  activeVendorIndex = 0;
  isEditMode = false;

  /* FIXED COLUMN */
  tableColumn: string[] = [
    'Milestone',
    'Deliverables Guideline',
    'Sub-Deliverables',
    'Major Tasks',
    'Subtasks',
    'Duration(weeks)',
    'Start Date',
    'End Date'
  ];
  getFileName(path: string | null | undefined): string {
    if (!path) return '';
    return path.split('/').pop() || '';
  }


  /* ================= BUILD TABS ================= */
  buildVendorTabs(res: any) {

    const vendorMap = res?.vendors || {};

    this.vendorTabs = Object.keys(vendorMap).map((name: any, index: number) => {

      const vendorObj = vendorMap[name] || {};

      /* 🔥 Spark Grant ID */
      const sparkId = vendorObj?.id ?? null;

      /* 🔥 Vendor ID */
      const vendorId = vendorObj?.vendor?.id ?? null;

      /* ===== GRANT DATA ===== */
      const grant = {
        id: sparkId,
        spark_grant_approve: vendorObj?.spark_grant_approve ?? '',
        matching_contribution: vendorObj?.matching_contribution ?? '',
        start_date: vendorObj?.start_date ?? '',
        end_date: vendorObj?.end_date ?? '',
        sign_document: vendorObj?.sign_document ?? null
        // sign_document: vendorObj?.data?.sign_document ?? null
      };

      /* 🔥 Patch first vendor */
      if (index === 0) {
        this.sparkForms.patchValue({
          spark_grant_approve: grant.spark_grant_approve,
          matching_contribution: grant.matching_contribution,
          start_date: grant.start_date,
          end_date: grant.end_date
        });

        this.sparkForms.get('sign_document')?.setValue(null);
      }

      /* ===== TABLE DATA ===== */
      let data: any[] = [];

    if (vendorObj?.milestone && vendorObj.milestone.length > 0) {

  data = vendorObj.milestone.map((item: any) => ({
    'Milestone': item?.title ?? '',
    'Deliverables Guideline': item?.deliverable ?? '',
    'Sub-Deliverables': item?.sub_deliverable ?? '',
    'Major Tasks': item?.major_task ?? '',
    'Subtasks': item?.subtask ?? '',
    'Duration(weeks)': item?.duration_week ?? '',
    'Start Date': item?.start_date ?? '',
    'End Date': item?.end_date ?? '',
  }));

} else {
  // ✅ SHOW STATIC DATA
  data = this.getStaticWbsData();
}

      return {
        label: `Vendor ${index + 1}`,
        name,
        sparkId,   // ✅ spark grant id
        vendorId,  // ✅ vendor id
        data,
        grant
      };

    });

    this.activeVendorIndex = 0;

    console.log('✅ Vendor Tabs:', this.vendorTabs);
  }


  /* ================= BLANK ROW ================= */
getStaticWbsData() {
  return [

    {
      'Milestone': 'Kickoff [Tranche-1 – 10%]',
      'Deliverables Guideline': `HPSC Recommendation + Technical Appraisal conducted as per iDEX Tech/Product Management practices
Evaluate compliance of MVP (concept & design)
Validate progress/deliverables as per expectations`,
      'Sub-Deliverables': `Product Compliance [%]
Product Maturity [TRL-100%]
Deliverables: Spark Grant Agreement`,
      'Major Tasks': `Spark Grant Agreement signing`,
      'Subtasks': `Project Technical Appraisal`,
      'Duration(weeks)': 'x Weeks',
      'Start Date': '',
      'End Date': ''
    },

    {
      'Milestone': 'Delivery of MVP Product Development Plan (TRL-8 grade) [Tranche-2 – 20%]',
      'Deliverables Guideline': `✔ Product Compliance
Achieve minimum 50% MVP compliance to PDS
High level of completeness

✔ Product Maturity
Demonstrate TRL-3/4 readiness
Validate functional fitness of core technology`,
      'Sub-Deliverables': `Product Compliance [%]
Product Maturity [TRL]

Deliverables:
Product design
Optimization
Engineering drawing release`,
      'Major Tasks': `Systems Level Model Development`,
      'Subtasks': `Systems level GTG & WHR model development and validation`,
      'Duration(weeks)': '4',
      'Start Date': '',
      'End Date': ''
    },

   

    {
      'Milestone': 'Delivery of Functional Testing Prototype [Tranche-3 – 30%]',
      'Deliverables Guideline': `✔ Product Compliance
Minimum 50% compliance to PDS

✔ Product Maturity
TRL-4/5 readiness in all subsystems`,
      'Sub-Deliverables': `Product Compliance [%]
Product Maturity [TRL]

Deliverables:
Realization of heat source GTG compressor & combustor section
Realization of supercritical WHR compressor section`,
      'Major Tasks': `GTG Heat Source Components`,
      'Subtasks': `Fuel injection system development → 30 (T0+16 to T0+46)
Annular combustor development → 30 (T0+16 to T0+46)`,
      'Duration(weeks)': '30',
      'Start Date': '',
      'End Date': ''
    },

   

    {
      'Milestone': 'Delivery of Integration & Validation Ready Prototype [Milestone 3]',
      'Deliverables Guideline': `✔ Product Compliance
Minimum 75% compliance

✔ Product Maturity
TRL-5/6 readiness`,
      'Sub-Deliverables': `GTG turbine system`,
      'Major Tasks': `Turbine Section Development`,
      'Subtasks': `GTG shaft & bearing system → 24 (T0+64 to T0+88)
GTG turbine & assembly → 40 (T0+64 to T0+104)
Compressor test stand instrumentation → 24 (T0+64 to T0+104)`,
      'Duration(weeks)': '40',
      'Start Date': '',
      'End Date': ''
    },

    {
      'Milestone': 'Delivery of User Trials / QAR MVP Prototype [Tranche-4 – 30%]',
      'Deliverables Guideline': `✔ Product Maturity
TRL-5/6 readiness

✔ Product Compliance
100% compliance to PDS

✔ Product Maturity Final
TRL-6/7 readiness

✔ Business Plan & External Investment`,
      'Sub-Deliverables': `Power turbine + WHR system`,
      'Major Tasks': `Supercritical WHR`,
      'Subtasks': `Realization of supercritical turbine → 32 (T0+64 to T0+96)
GTG free power turbine → 24 (T0+104 to T0+128)
Reduction gearbox → 24 (T0+104 to T0+128)
Supercritical evaporator → 16 (T0+104 to T0+120)`,
      'Duration(weeks)': '32',
     'Start Date': '',
      'End Date': ''
    },

    {
      'Milestone': 'Delivery of Production Ready Design [Tranche-5 – 10%]',
      'Deliverables Guideline': `✔ Product Maturity
TRL-8 readiness

✔ Technology Viability
✔ External Investments`,
      'Sub-Deliverables': `Product Maturity [TRL-8]`,
      'Major Tasks': `Systems Integration`,
      'Subtasks': `Supercritical condenser realization → 8 (T0+128 to T0+136)
Closed loop integration with GTG heat source
Factory acceptance trials → 8 (T0+136 to T0+144)`,
      'Duration(weeks)': '8',
      'Start Date': '',
      'End Date': ''
    },
   

  ];
}
  // createBlankRows() {
  //   return Array.from({ length: 5 }).map(() => {
  //     const row: any = {};
  //     this.tableColumn.forEach(col => row[col] = '');
  //     return row;
  //   });
  // }


  /* ================= TAB CHANGE ================= */
  changeVendorTab(index: number) {

    this.activeVendorIndex = index;

    const grant = this.vendorTabs[index]?.grant || {};

    this.sparkForms.patchValue({
      spark_grant_approve: grant.spark_grant_approve ?? '',
      matching_contribution: grant.matching_contribution ?? '',
      start_date: grant.start_date ?? '',
      end_date: grant.end_date ?? '',
    });

    this.sparkForms.get('sign_document')?.setValue(null);
  }


  /* ================= EDIT ================= */
  enableEdit() {
    this.isEditMode = true;
  }


  /* ================= FILE ================= */
  onGrantFileChange(event: any) {

    const file = event.target?.files?.[0];
    if (!file) return;

    this.sparkForms.patchValue({
      sign_document: file
    });

    console.log('📁 File Selected:', file);
  }


  /* ================= SAVE ================= */
  saveVendorData() {

    const activeTab = this.vendorTabs[this.activeVendorIndex];
    const formValue = this.sparkForms.value;

    /* ===== SAFE ID CHECK ===== */
    if (!activeTab?.sparkId && !activeTab?.vendorId) {
      console.error('Missing Spark or Vendor ID');
      return;
    }

    /* ===== REMOVE EMPTY ROW ===== */
    const validRows = activeTab.data.filter((row: any) =>
      Object.values(row).some(v => v)
    );

    /* ===== WBS TABLE ===== */
    const wbsRows = validRows.map((row: any, index: number) => ({
      row_number: index + 1,
      Milestone: row['Milestone'] ?? '',
      'Deliverables Guideline': row['Deliverables Guideline'] ?? '',
      'Sub-Deliverables': row['Sub-Deliverables'] ?? '',
      'Major Tasks': row['Major Tasks'] ?? '',
      Subtasks: row['Subtasks'] ?? '',
      'Duration(weeks)': row['Duration(weeks)'] ?? '',
      'Start Date': row['Start Date'] ?? '',
      'End Date': row['End Date'] ?? '',
    }));

    /* ===== FormData ===== */
    const formData = new FormData();

    /* 🔥 IMPORTANT: Send spark id */
    // if (activeTab.sparkId) {
    //   formData.append('id', activeTab.sparkId.toString());
    // }

    /* 🔥 Vendor */
    if (activeTab.sparkId) {
      formData.append('vendor_id', activeTab.sparkId.toString());
    }
    /* 🔥 File */
    if (formValue.sign_document instanceof File) {
      formData.append('sign_document', formValue.sign_document);
    } else {
      const oldFile = activeTab?.grant?.sign_document;
      if (oldFile) {
        formData.append('sign_document', oldFile);
      }
    }

    /* 🔥 Grant Fields */
    const sparkGrant = Number(formValue.spark_grant_approve || 0).toFixed(2);
    const matchingContribution = Number(formValue.matching_contribution || 0).toFixed(2);

    formData.append('spark_grant_approve', sparkGrant);
    formData.append('matching_contribution', matchingContribution);
    formData.append('start_date', formValue.start_date ?? '');
    formData.append('end_date', formValue.end_date ?? '');

    /* 🔥 File */
    if (formValue.sign_document instanceof File) {
      formData.append('sign_document', formValue.sign_document);
    }

    /* 🔥 WBS */
    formData.append('wbs_sheet', JSON.stringify(wbsRows));

    /* ===== DEBUG ===== */
    console.log('🔥 FINAL FORM DATA');
    formData.forEach((v, k) => console.log(k, v));

    /* ===== API ===== */
    this.api.putAPI(`/idex/spark/grant/`, formData)
      .subscribe(() => {

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Vendor data saved successfully',
        });

        this.isEditMode = false;
        this.getSparkDetails();
      });

  }
}